import { ScopeGroup, ScopeNamespace } from './constants';
import { getCouponEntityName } from './getCouponEntityName';
export async function getRewardCondition(_ref, reward) {
  let {
    t,
    httpClient,
    formatNumber,
    formatCurrency
  } = _ref;
  const {
    couponOptions
  } = reward;
  if (!couponOptions) {
    return '';
  }
  const {
    minimumSubtotal,
    scope,
    limitedToOneItem,
    discountedCycleCount
  } = couponOptions;
  if (minimumSubtotal !== undefined) {
    return t('condition.minimum-subtotal', {
      amount: formatCurrency(minimumSubtotal)
    });
  } else if (scope !== undefined) {
    const {
      namespace,
      group
    } = scope;
    const entityName = await getCouponEntityName({
      couponScope: scope,
      httpClient
    });

    // Stores
    if (namespace === ScopeNamespace.Stores) {
      if ((group == null ? void 0 : group.name) === ScopeGroup.Product && entityName) {
        if (limitedToOneItem) {
          return t('condition.product.one-item', {
            product: entityName
          });
        } else {
          return t('condition.product', {
            product: entityName
          });
        }
      } else if ((group == null ? void 0 : group.name) === ScopeGroup.Collection && entityName) {
        if (limitedToOneItem) {
          return t('condition.category.one-item', {
            category: entityName
          });
        } else {
          return t('condition.category', {
            category: entityName
          });
        }
      } else if (limitedToOneItem) {
        return t('condition.stores.one-item');
      }
    }
    // Events
    else if (namespace === ScopeNamespace.Events) {
      if ((group == null ? void 0 : group.name) === ScopeGroup.Event && entityName) {
        if (limitedToOneItem) {
          return t('condition.event.one-item', {
            event: entityName
          });
        } else {
          return t('condition.event', {
            event: entityName
          });
        }
      } else if ((group == null ? void 0 : group.name) === ScopeGroup.Ticket && entityName) {
        if (limitedToOneItem) {
          return t('condition.ticket.one-item', {
            ticket: entityName
          });
        } else {
          return t('condition.ticket', {
            ticket: entityName
          });
        }
      } else if (limitedToOneItem) {
        return t('condition.events.one-item');
      }
    }
    // Pricing Plans
    else if (namespace === ScopeNamespace.PricingPlans) {
      if ((group == null ? void 0 : group.name) === ScopeGroup.Plan && entityName) {
        if (typeof discountedCycleCount !== 'number') {
          return t('condition.billing-cycle.all.plan', {
            plan: entityName
          });
        } else if (discountedCycleCount === 1) {
          return t('condition.billing-cycle.first.plan', {
            plan: entityName
          });
        } else {
          return t('condition.billing-cycle.custom.plan', {
            cycles: formatNumber(discountedCycleCount),
            plan: entityName
          });
        }
      } else {
        if (typeof discountedCycleCount !== 'number') {
          return t('condition.billing-cycle.all');
        } else if (discountedCycleCount === 1) {
          return t('condition.billing-cycle.first');
        } else {
          return t('condition.billing-cycle.custom', {
            cycles: formatNumber(discountedCycleCount)
          });
        }
      }
    }
    // Bookings
    else if (namespace === ScopeNamespace.Bookings) {
      if ((group == null ? void 0 : group.name) === ScopeGroup.Service && entityName) {
        if (limitedToOneItem) {
          return t('condition.service.one-item', {
            service: entityName
          });
        } else {
          return t('condition.service', {
            service: entityName
          });
        }
      } else if (limitedToOneItem) {
        return t('condition.bookings.one-item');
      }
    }
    // Restaurants
    else if (namespace === ScopeNamespace.Restaurants) {
      if ((group == null ? void 0 : group.name) === ScopeGroup.Menu && entityName) {
        if (limitedToOneItem) {
          return t('condition.menu.one-item', {
            menu: entityName
          });
        } else {
          return t('condition.menu', {
            menu: entityName
          });
        }
      } else if ((group == null ? void 0 : group.name) === ScopeGroup.MenuSection && entityName) {
        if (limitedToOneItem) {
          return t('condition.menu-section.one-item', {
            section: entityName
          });
        } else {
          return t('condition.menu-section', {
            section: entityName
          });
        }
      } else if ((group == null ? void 0 : group.name) === ScopeGroup.MenuItem && entityName) {
        if (limitedToOneItem) {
          return t('condition.menu-item.one-item', {
            item: entityName
          });
        } else {
          return t('condition.menu-item', {
            item: entityName
          });
        }
      } else if (limitedToOneItem) {
        return t('condition.restaurants.one-item');
      }
    }
    // Online Programs
    else if (namespace === ScopeNamespace.OnlinePrograms) {
      if ((group == null ? void 0 : group.name) === ScopeGroup.Program && entityName) {
        return t('condition.online-program', {
          program: entityName
        });
      }
    }
  }
  return '';
}
//# sourceMappingURL=getRewardCondition.js.map